import { FeatureFlag } from 'featureFlags';
import Immutable from 'immutable';
import { getAppServices } from 'providers/app-services';
import { AppState, AppStateActionParams } from 'records/AppState';
import { DocId } from 'records/Doc';
import { Link } from 'records/Link';
import { getLinks } from 'services/linkService';

export interface LinkActions {
  getLinks: (
    actionParams: AppStateActionParams,
    documentId: DocId
  ) => Promise<AppState>;
}

const linkActions: LinkActions = {
  getLinks: async (
    { state }: AppStateActionParams,
    pageid: DocId
  ): Promise<AppState> => {
    const { featureFlagService } = getAppServices();

    if (!featureFlagService.hasFeature(FeatureFlag.EnableLinks)) {
      return state();
    }

    const links = await getLinks(pageid);

    const g = links
      .groupBy((s) => s.pageid)
      .map((spArr) => {
        return spArr.reduce(
          (acc, ss) => acc.set(ss.linkid, ss),
          Immutable.OrderedMap<string, Link>()
        );
      })
      .toOrderedMap();
    return state().set('links', g);
  },
};

export default linkActions;
